module.exports = __webpack_public_path__ + "img/top_catch03.46747da0.jpg";